import { render, staticRenderFns } from "./watiApplyReturnExchange.vue?vue&type=template&id=6fc5fa39"
import script from "./watiApplyReturnExchange.vue?vue&type=script&lang=js"
export * from "./watiApplyReturnExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports